import React from 'react'
import { Route, Routes } from 'react-router'
import GrievanceAdminRoutes from './GrievanceAdminRoutes'
import ManagerLandingPage from '../app/dashboard/pages/ManagerLandingPage'
import { useAuth } from '../context/AuthContext'
import GrievanceDataGridPage from '../app/admin/grievance/pages/GrievanceDataGridPage'
import FeedbackListPage from '../app/admin/feedback/pages/FeedbackListPage'
import GrievancePendingReportPage from '../app/admin/reports/pages/GrievancePendingReportPage'


function ManagerRoutes() {
  const {authUser} = useAuth()
  return (
    <>
      <Routes>
        {/* Manager */}
        {authUser.role == 2 && <Route path="/" element={ <ManagerLandingPage /> }></Route>  }
        <Route path="/grievance/data-grid" element={ <GrievanceDataGridPage /> }></Route>
        <Route path="/feedback/list" element={ <FeedbackListPage /> }></Route>

        <Route path="/grievance/pending-report" element={ <GrievancePendingReportPage /> }></Route>
      </Routes>
      <GrievanceAdminRoutes/>
    </>
  )
}

export default ManagerRoutes